"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(response, json) {
  return Promise.reject({
    message: "Fetch request failed with status: ".concat(json.Status),
    response: response,
    json: json
  });
};

exports["default"] = _default;